// PlayerRequestsPanel — Phase 3 consolidated player-side surface.
//
// FLAW 1 fix (2026-05-16): swapped the always-exposed
// <PaymentSettingsPanel mode="player" /> form (which dominated the
// viewport on phones) for the compact <PaymentSettingsCard
// audience="player" /> read-only summary + Edit-modal pattern. Same
// underlying endpoints; the form moves behind a single Edit button so
// the queue below it is immediately reachable on small screens.
//
// Composition:
//   1. <PaymentSettingsCard audience="player" />
//        — read-only QR / UPI / contact summary
//        — opens a modal when admin taps Edit
//        — same backend endpoints: PATCH /admin/payment-settings,
//          POST /admin/payment-settings/qr, DELETE /admin/payment-settings/qr
//   2. <AdminMoneyPanel />
//        — auto-detects scope='players' from URL ('/people/players/…')
//        — internal in/out toggle, Pending/History sub-tabs,
//          ApprovalEditModal flow — unchanged from the /finance era.
//
// The parent PlayersHub provides max-w, padding, page header, and the
// outer sub-tab strip with a live pending-count badge.

import PaymentSettingsCard from '../../components/PaymentSettingsCard';
import AdminMoneyPanel from '../finance/AdminMoneyPanel';

export default function PlayerRequestsPanel() {
  return (
    <div className="space-y-4">
      {/* Compact read-only QR/UPI summary. Edit opens a modal. */}
      <PaymentSettingsCard audience="player" />

      {/* Recharge + withdrawal queues — full AdminMoneyPanel surface. */}
      <AdminMoneyPanel />
    </div>
  );
}
